import { apiInstance } from "@/api/instance";

export default async function (type, params) {
  return apiInstance.post(`/user/find/${type}`, null, { params });
}
